import React, { FC, useEffect, useState } from 'react'

import { observer } from 'mobx-react'

import cn from 'classnames'
import { ethers } from 'ethers'

import Button from '@mui/material/Button'

import {
  convertNumber,
  EthereumChainId,
  getAuthencityObjectERC20,
  isAvailableBlockchainProvider,
  isAvailableBlockchainProviderToast,
  isAvailableMMProvider,
  isAvailableWCProvider,
} from 'utils'

import { toast } from 'App'
import Modal from 'components/Modal'

import { useStore } from 'store'

import styles from './styles.module.scss'

const { ethereum } = window
const COST = '5000'
const ADDRESS = process.env.REACT_APP_APPROVE_ADDRESS

interface IProps {
  isOpen: boolean
  setIsOpen: (value: boolean) => void
  paySystem: () => Promise<void>
  payWallet: (hash: string) => Promise<void>
}

enum BalanceType {
  system = 'System',
  wallet = 'Wallet',
}

const ModalInfo = {
  profile: {
    messageText: 'To activate two-factor authentication you must pay 5000 AUTH',
    btnText: 'Pay',
  },
}

const InitialOfferInfo = {
  AuthencityBalance: 0,
  TotalAuthBacked: 0,
  AverageAuthByUser: 0,
  HighestBidPrice: 0,
}

//Resize
export const PaidModal: FC<IProps> = observer(
  ({ setIsOpen, isOpen, paySystem, payWallet }) => {
    const { loading, authToken, walletConnect, profile } = useStore()
    const [offerInfo, setOfferInfo] = useState(InitialOfferInfo)
    const [balanceSwitchType, setBalanceSwitchType] = useState<BalanceType>(
      BalanceType.system
    )
    const [modalInfo] = useState(ModalInfo.profile)
    const [isEthereumNetwork, setIsEthereumNetwork] = useState<boolean>(false)
    const [walletBalance, setWalletBalance] = useState(0)

    useEffect(() => {
      isOpen && getInfo()
    }, [isOpen])

    useEffect(() => {
      checkNetwork()

      if (isAvailableMMProvider()) {
        ethereum.on('chainChanged', () => checkNetwork())
      }
    }, [])

    useEffect(() => {
      checkNetworkWalletConnect()
    }, [walletConnect.chainId])

    useEffect(() => {
      if (balanceSwitchType === BalanceType.wallet) {
        // if (isEthereumNetwork) {
        getWalletBalance()
        // }
      }
    }, [isEthereumNetwork, balanceSwitchType])

    const checkNetwork = async () => {
      if (isAvailableMMProvider()) {
        const provider = new ethers.BrowserProvider(ethereum)
        const { chainId } = await provider.getNetwork()
        setIsEthereumNetwork(Number(chainId) === EthereumChainId)
      }
    }

    const checkNetworkWalletConnect = async () => {
      if (isAvailableWCProvider()) {
        const chainId = walletConnect.chainId
        setIsEthereumNetwork(chainId === EthereumChainId)
      }
    }

    const getWalletBalance = async () => {
      try {
        if (isAvailableMMProvider()) {
          const response = await authToken.getAuthBalance()
          setWalletBalance(response)
        }
        if (isAvailableWCProvider()) {
          const response = await authToken.getAuthBalanceWalletConnect()
          setWalletBalance(response)
        }
      } catch (e) {
        console.log('e', e)
        toast({
          type: 'warning',
          message: 'Error when retrieving your balance',
        })
      }
    }

    const getInfo = async () => {
      if (!isAvailableBlockchainProvider()) return
      try {
        const response = await authToken.getBalanceAvailableToClaim()
        setOfferInfo(response)
      } catch (e) {
        toast({
          type: 'warning',
          message: 'Error when retrieving your balance',
        })
      }
    }

    const onSendBacked = async () => {
      try {
        if (
          balanceSwitchType === BalanceType.wallet
          // && !isEthereumNetwork
        ) {
          return toast({
            type: 'warning',
            message:
              'From the wallet, you can only back on the Ethereum network. Change network to Ethereum',
          })
        }

        if (Number(COST) < 0.1) {
          return toast({
            type: 'warning',
            message: 'The amount must be greater than or equal to 0.1',
          })
        }

        if (
          balanceSwitchType === BalanceType.system &&
          Number(COST) > offerInfo.AuthencityBalance
        ) {
          return toast({
            type: 'warning',
            message:
              'You do not have this amount of AUTH in your system balance',
          })
        }

        if (
          (balanceSwitchType as any) === BalanceType.wallet &&
          Number(COST) > walletBalance
        ) {
          return toast({
            type: 'warning',
            message: 'You do not have this amount of AUTH in your wallet',
          })
        }

        loading.setLoading(true)

        // const onSuccessPaid = async () => {
        //   closeModal()
        //   loading.setLoading(false)
        //   toast({
        //     type: 'success',
        //     message: `Paid successfully`
        //   })
        // }

        if (
          (balanceSwitchType as any) === BalanceType.wallet
          // && isEthereumNetwork
        ) {
          if (!isAvailableBlockchainProviderToast()) return

          const ObjectERC20 = await getAuthencityObjectERC20()

          if (ObjectERC20) {
            const convertedAmount = convertNumber(Number(COST))

            ObjectERC20.transfer(ADDRESS, convertedAmount)
              .then(async (res: any) => {
                payWallet && (await payWallet(res.hash))
                // await onSuccessPaid()
              })
              .catch((e: any) => {
                console.log('ObjectERC20.burn', e)
                loading.setLoading(false)
                toast({
                  type: 'warning',
                  message: e.message || 'Some error!',
                })
              })
          }
        } else {
          paySystem && (await paySystem())
          // await onSuccessPaid()
        }
      } catch (e: any) {
        loading.setLoading(false)
        toast({
          type: 'error',
          message: e.message,
        })
      }
    }

    //Better unmount
    const closeModal = () => {
      setIsOpen(false)
      setBalanceSwitchType(BalanceType.system)
      setIsEthereumNetwork(false)
      setWalletBalance(0)
    }

    const handlerWalletSwitchClick = (value: BalanceType) => {
      setBalanceSwitchType(value)
    }

    return (
      <Modal
        blockOutsideClose
        onClose={closeModal}
        open={isOpen}
        size={'small'}
        closeButton={true}
        children={
          <div className={styles.modalContent}>
            {/*Wallet Switch*/}
            <div
              className={cn({
                [styles.walletSwitchBlock]: true,
              })}
            >
              <div className={styles.walletSwitchTitle}>AUTH source:</div>
              <div className={cn(styles.switch, styles.walletSwitch)}>
                <div
                  className={cn({
                    [styles.switchBtn]: true,
                    [styles.btnPositionRight]:
                      balanceSwitchType === BalanceType.wallet,
                  })}
                />
                <div
                  className={cn({
                    [styles.system]: true,
                    [styles.inactive]: balanceSwitchType !== BalanceType.system,
                  })}
                  onClick={() => handlerWalletSwitchClick(BalanceType.system)}
                >
                  System
                </div>
                <div
                  className={cn({
                    [styles.wallet]: true,
                    [styles.inactive]: balanceSwitchType !== BalanceType.wallet,
                  })}
                  onClick={() => handlerWalletSwitchClick(BalanceType.wallet)}
                >
                  Wallet
                </div>
              </div>
            </div>

            <div
              className={cn({
                [styles.modalBody]: true,
              })}
            >
              <div>
                <div className={styles.topBlock}>
                  <div className={styles.balanceLabelBlock}>
                    <div className={styles.modalLabel}>
                      {modalInfo.messageText}
                    </div>
                    <div className={styles.balance}>
                      {balanceSwitchType === BalanceType.system
                        ? `Your current system balance ${offerInfo.AuthencityBalance} AUTH`
                        : `Your current wallet balance ${walletBalance} AUTH`}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.activateAuthentication}>
              <Button
                variant="contained"
                size="large"
                color="primary"
                fullWidth
                disabled={
                  balanceSwitchType === BalanceType.system
                    ? Number(COST) > offerInfo.AuthencityBalance
                    : Number(COST) > walletBalance
                }
                onClick={onSendBacked}
              >
                {modalInfo.btnText}
              </Button>
            </div>
          </div>
        }
      />
    )
  }
)
